import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { TermoListagem } from "./TermoListagem";
import { useTermosStore } from "src/store/termos/termos.store";

const PAGE_TITLE = "Termos";

const TermosAcessoPage = () => {
  const { termosAceitos } = useTermosStore(store => store.state.data);

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <TermoListagem 
            open={true}
            termos={termosAceitos}
          />
        </div>
      </div>
    </div>
  );
};

export { TermosAcessoPage };